import React, { useEffect } from "react";
import MyLoader from "../component/reusebale/myLoader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as AuthAction from "../store/actions/auth/AuthAction";
import { hasValidLoginCredentials } from "../utils/storageUtils";

const Middleware = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeApp = async () => {
      // First, hydrate state from localStorage
      await dispatch(AuthAction.HydrateStateAction());

      // Check if we have valid login data after hydration
      if (hasValidLoginCredentials()) {
        // User is logged in, navigate to dashboard
        navigate("/dashboard");
      } else {
        // No valid login data found, navigate to login
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      }
    };

    initializeApp();
  }, [dispatch, navigate]);

  return (
    <div className="flex h-screen justify-center items-center">
      <MyLoader />
    </div>
  );
};

export default Middleware;
